import React from "react";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";

class ProtectedRouteUsers extends React.Component {
  render() {
    const Component = this.props.component;
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user?.token) {
      return <Redirect to={{ pathname: "/" }} />;
    }

    const decoded = jwt_decode(user.token);
    const ruolo = parseInt(decoded.RUOLO);

    const canManageUsers = ruolo === 6;

    return canManageUsers ? (
      <Component />
    ) : (
      <Redirect to={{ pathname: "*" }} />
    );
  }
}

export default ProtectedRouteUsers;